import React, { useCallback } from 'react';
import { Wrapper, Text, Heading } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { useModal } from 'lib/hooks';
import { getOffer } from 'store/booking/bookingSelectors';
import TextButton from 'components/TextButton';
import Modal from 'components/Modal';
import { useDataLayer } from 'hooks/useDataLayer';
import Markup from 'components/Markup';

const OfferDetails = () => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const offerDetails = useSelector(getOffer);
  const offerName = offerDetails.name;
  const offerDescription = offerDetails.description;

  const openOfferDetailsModal = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Offer Details Pop Up', value: 'Link Selected' });
  }, [openModal, emitInteractionEvent]);

  return (
    <Wrapper>
      <TextButton onClick={openOfferDetailsModal} color="greys.charcoal" fontSize={['sm', 'base']} lineHeight="loose">
        {offerName}
      </TextButton>
      <Modal {...modalProps} title="Offer description">
        <Text fontSize={['sm', 'base']} display="block" mb="5">
          <Heading.h4>{offerName}</Heading.h4>
          <Markup content={offerDescription} data-testid="offer-description-body" />
        </Text>
      </Modal>
    </Wrapper>
  );
};

export default OfferDetails;
